import styled from "styled-components";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import StarBorderRoundedIcon from "@mui/icons-material/StarBorderRounded";
import StarRoundedIcon from "@mui/icons-material/StarRounded";

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 2000;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ModalContainer = styled.div`
  background: #fff;
  border-radius: 10px;
  max-width: 600px;
  width: 90%;
  height: 85vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  @media (max-width: 768px) {
    width: 100%;
    max-width: 100%;
    height: 100vh;
    border-radius: 0;
  }
`;

export const ScrollableContent = styled.div`
  flex: 1;
  overflow-y: auto;
  min-height: 0;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid #eee;
`;

export const ProgressText = styled.span`
  font-size: 0.875rem;
  color: #666;
  font-weight: 600;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #333;
  padding: 0;
  line-height: 1;

  &:hover {
    color: #000;
  }
`;

export const CardImage = styled.img`
  width: 100%;
  max-height: 300px;
  object-fit: cover;
`;

export const CardBody = styled.div`
  padding: 1.25rem;
`;

export const CardTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: 900;
  margin: 0 0 0.5rem 0;
  font-family: ${(props) => props.theme.fonts.primary};
`;

export const CardDirector = styled.p`
  font-size: 0.95rem;
  color: #555;
  margin: 0 0 0.5rem 0;
`;

export const GenreList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
  margin-bottom: 0.75rem;
`;

export const GenreChip = styled.span`
  background: #f0f0f0;
  color: #333;
  padding: 0.2rem 0.6rem;
  border-radius: 12px;
  font-size: 0.8rem;
  font-weight: 500;
`;

export const CardDescription = styled.p`
  font-size: 0.9rem;
  line-height: 1.5;
  color: #333;
  margin: 0;
`;

export const ActionsContainer = styled.div`
  padding: 0 1.25rem 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const ActionButtonRow = styled.div`
  display: flex;
  gap: 10px;
`;

export const StyledBookmarkIcon = styled(BookmarkIcon)`
  color: inherit;
  font-size: 1.25rem !important;
`;

export const StyledBookmarkBorderIcon = styled(BookmarkBorderIcon)`
  color: inherit;
  font-size: 1.25rem !important;
`;

export const StyledStarRoundedIcon = styled(StarRoundedIcon)`
  color: inherit;
  font-size: 1.125rem;
`;

export const StyledStarBorderRoundedIcon = styled(StarBorderRoundedIcon)`
  color: inherit;
  font-size: 1.125rem;
`;

export const PriorityButton = styled.button`
  display: flex;
  gap: 4px;
  justify-content: center;
  align-items: center;
  flex: 1;
  height: 3rem;
  border-radius: 0.3125rem;
  border: none;
  background-color: ${(props) =>
    props.$active
      ? props.$buttonType === "maybe"
        ? "#83DAFA"
        : "#f9da1c"
      : "rgba(0, 0, 0, 0.1)"};
  color: #000;
  font-family: ${(props) => props.theme.fonts.primary};
  font-size: 1.125rem;
  font-weight: 700;
  cursor: pointer;

  &:hover {
    background-color: ${(props) =>
      props.$active ? "#000" : "#7F7F7F"};
    color: #fff;

    ${StyledBookmarkIcon}, ${StyledBookmarkBorderIcon}, ${StyledStarRoundedIcon}, ${StyledStarBorderRoundedIcon} {
      color: ${(props) =>
        props.$buttonType === "maybe" ? "#83DAFA" : "#f9da1c"};
    }
  }

  &:active {
    background-color: #000;
  }
`;

export const SkipButton = styled.button`
  display: inline-flex;
  width: 100%;
  height: 2.75rem;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  color: #000000;
  border: 2px solid #000000;
  border-radius: 5px;
  font-size: 0.875rem;
  font-weight: 700;
  text-transform: uppercase;
  cursor: pointer;
  transition:
    background-color 0.3s ease,
    color 0.3s ease;

  &:hover {
    background-color: #000;
    color: #fff;
  }

  &:focus {
    outline: none;
  }
`;

export const OptionsRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 1.25rem;
  border-top: 1px solid #eee;
`;

export const ToggleLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.85rem;
  color: #555;
  cursor: pointer;

  input {
    cursor: pointer;
  }
`;

export const ShuffleButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: #e8e8e8;
  color: #000;
  border: none;
  padding: 0.4rem 0.75rem;
  cursor: pointer;
  border-radius: 5px;
  font-size: 0.8rem;
  font-weight: 700;
  text-transform: uppercase;
  transition:
    background-color 0.3s ease,
    color 0.3s ease;

  &:hover {
  background-color: #000000;
  color: #ffffff;
  }

  &:focus {
    outline: none;
  }
`;

export const CompletionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem 1.25rem;
  text-align: center;
  gap: 1rem;
`;

export const CompletionText = styled.p`
  font-size: 1.25rem;
  font-weight: 700;
  color: #333;
`;

export const CompletionCloseButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: #000000;
  color: #ffffff;
  border: none;
  padding: 0.75rem 2rem;
  cursor: pointer;
  border-radius: 5px;
  font-size: 1rem;
  font-weight: 700;
  text-transform: uppercase;
  transition:
    background-color 0.3s ease,
    color 0.3s ease;

  &:hover {
    background-color: #e8e8e8;
    color: #000;
  }

  &:focus {
    outline: none;
  }
`;
